import React, { useMemo, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Button, Text } from '@rneui/themed';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@rneui/themed';
import _ from 'lodash';
import dayjs from 'dayjs';

const ActivateChatButton = ({ total, enableChat }) => {
  const { t } = useTranslation();
  const [infoVisible, setInfoVisible] = useState(false);

  const numDaysInDiary = useMemo(() => {
    if (!total?.daily) {
      return null;
    }
    const nonZeroDays = Object.fromEntries(
      Object.entries(total.daily).filter(([key, value]) => value !== 0)
    );
    const minDate = _.min(Object.keys(nonZeroDays));
    return dayjs().diff(minDate, 'day');
  }, [total?.daily]);

  const onOkPress = () => {
    setInfoVisible(false);
    enableChat();
  };

  return (
    <>
      <Button
        title={t('chat.contactAdvisor')}
        onPress={() => setInfoVisible(true)}
      />
      <Dialog
        overlayStyle={styles.overlayStyle}
        isVisible={infoVisible}
        onBackdropPress={() => setInfoVisible(false)}
      >
        <Dialog.Title title={t('chat.contactAdvisor')} />
        <Text>{t('chat.advisorInfo')}</Text>
        <Dialog.Actions>
          {numDaysInDiary >= 7 && (
            <Dialog.Button
              title={t('activate')}
              type="solid"
              onPress={onOkPress}
            />
          )}

          <Dialog.Button
            title={t('cancel')}
            type="outline"
            onPress={() => setInfoVisible(false)}
          />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

const styles = StyleSheet.create({
  overlayStyle: {
    backgroundColor: 'white',
  },
});

export default ActivateChatButton;
